import watchTransactionHistory from './transactionHistory'

export default watchTransactionHistory
